module.exports = __webpack_public_path__ + "img/3.e08b6152.png";